import { FC } from 'react';

interface Props {
  SVGIcon: FC<React.SVGProps<SVGSVGElement>>;
  title: string;
  subtitle: string;
}

const FeatureCard: FC<Props> = ({ SVGIcon, title, subtitle }) => {
  return (
    <div className='flex flex-col items-center text-center gap-4'>
      <div className='text-[#0a1f44] dark:text-blue-400 transition-colors duration-200'>
        <SVGIcon />
      </div>
      <h3 className="text-3xl font-bold text-gray-900 dark:text-slate-100 mb-2 transition-colors duration-200">{title}</h3>
      <p className="text-gray-600 dark:text-slate-300 text-sm transition-colors duration-200">
        {subtitle}
      </p>
    </div>
  );
};

export default FeatureCard;
